import React, { useState, useContext, useEffect, forwardRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import MaterialTable from "material-table";
import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FirstPage,
  LastPage,
  FilterList,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";

import DashboardContext from "../../context/facebook_profiles/dashboard/DashboardContext";
import PatchedPagination from "../layout/MTPagination";

const FacebookErrors = () => {
  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
  }));

  const classes = useStyles();

  const { facebook_errors, getFacebookError } = useContext(DashboardContext);

  const [rows, setRows] = useState([]);

  useEffect(() => {
    getFacebookError();
  }, []);

  useEffect(() => {
    if (facebook_errors) {
      setRows(facebook_errors);
    }
  }, [facebook_errors]);

  const column = [
    {
      field: "laptop",
      title: "Laptop",
      editable: "never",
      cellStyle: {
        width: 50,
        maxWidth: 50,
        fontSize: 12,
        textAlign: "left",
      },
    },
    {
      field: "profile_id",
      title: "Profile",
      editable: "never",
      cellStyle: {
        width: 50,
        maxWidth: 50,
        fontSize: 12,
        textAlign: "left",
      },
    },
    {
      field: "code",
      title: "Code",
      editable: "never",
      cellStyle: {
        width: 50,
        maxWidth: 50,
        fontSize: 12,
        textAlign: "left",
      },
    },
    {
      field: "error_subcode",
      title: "Subcode",
      editable: "never",
      cellStyle: {
        width: 50,
        maxWidth: 50,
        fontSize: 12,
        textAlign: "left",
      },
    },
    {
      field: "type",
      title: "Type",
      editable: "never",
      cellStyle: {
        width: 50,
        maxWidth: 50,
        fontSize: 12,
        textAlign: "left",
      },
    },
    {
      field: "message",
      title: "Message",
      editable: "never",
      cellStyle: {
        width: 550,
        minWidth: 550,
        fontSize: 12,
        textAlign: "left",
      },
    },
  ];

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid container spacing={1} justifyContent="flex-start">
          <Grid item xs={12}>
            <Typography variant="h4"> Facebook Error </Typography>
          </Grid>
          <Grid item xs={12}>
            <MaterialTable
              data={rows}
              columns={column}
              title=""
              icons={tableIcons}
              options={{
                sorting: true,
                toolbar: true,
                showTitle: true,
                pageSizeOptions: [20, 50],
                pageSize: 20,
                padding: "dense",
                headerStyle: {
                  fontWeight: "bold",
                  fontSize: 12,
                  textAlign: "left",
                  zIndex: 0,
                },
              }}
              components={{
                Pagination: PatchedPagination,
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default FacebookErrors;
